import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { Partner } from './partner';
import { Amenity } from '../uas/editing/targeting/targeting-data.interface';

@Injectable({ providedIn: 'root' })
export class AmenityService {
    constructor(private apiService: ApiService) { }

    getAmenity(amenity_type: string, locale: string, partner: Partner, cabinTargets: string[]): Observable<Amenity[]> {
        const carrier_code = partner.carrier_code;
        const cabin = cabinTargets.join(',');
        return this.apiService.post('/api/v2/amenities/display_text_keys/search', { amenity_type, locale, carrier_code, cabin });
    }
}